









































































import { Component, Inject, Mixins } from "vue-property-decorator";
import {
  ITicketProvider,
  ITicketProviderMethods
} from "@/models/providers/ticket";
import Context from "@/mixins/context";

@Component
export default class TicketControlsDropdown extends Mixins(Context) {
  // Inject
  @Inject({ from: "ticketProvider" })
  public readonly $ticketData!: () => ITicketProvider;
  @Inject({ from: "ticketProviderMethods" })
  public readonly $ticketMethods!: ITicketProviderMethods;
  // Data
  public isProcessing = false;
  // Computed
  public get ticketData() {
    return this.$ticketData();
  }
  public process(method) {
    if (this.isProcessing) return;
    this.isProcessing = true;
    Promise.all([method()]).finally(() => (this.isProcessing = false));
  }
}
